import { ProductList } from "../models/roto-schedule.model";

export function removeMoldingTaskIdFromProductLists(
    productLists: ProductList[],
    scheduledProductId: string
): ProductList[] {
    return productLists.map(productList => {
        const updatedProductList: ProductList = {
            id: productList.id,
            machineId: productList.machineId,
            armId: productList.armId,
            moldingTaskIds: productList.moldingTaskIds.filter(spi => spi !== scheduledProductId)
        }
        return updatedProductList;
    }).filter(productList => productList.moldingTaskIds.length > 0);
}